/**
 * Products with a SOW engine - the web's SOW gate (Generate SOW / "Generate all" / regenerate
 * overrides) reads this instead of a hardcoded product list. MUST equal the API's SOW config
 * registry (`listSowSupportedProductKeys()` in apps/api sow-product-config.ts); an API test pins
 * the two together, so adding a product's SOW config without listing it here fails loudly.
 */
export const SOW_SUPPORTED_PRODUCT_KEYS = [
    'oracle:netsuite',
    'rillet:rillet',
    'salesforce:salesforce',
    'maxio:maxio',
];
export function isSowSupportedProductKey(productKey) {
    return !!productKey && SOW_SUPPORTED_PRODUCT_KEYS.includes(productKey);
}
/**
 * Products whose GREENFIELD deals are scoped by a rule-based questionnaire, so the web hides the
 * Prioritization tab for them (every answered area is in scope; there is nothing to prioritise).
 */
export const QUESTIONNAIRE_GREENFIELD_PRODUCT_KEYS = [
    'oracle:netsuite',
    'rillet:rillet',
    'maxio:maxio',
];
export function isQuestionnaireGreenfieldProductKey(productKey) {
    return (!!productKey &&
        QUESTIONNAIRE_GREENFIELD_PRODUCT_KEYS.includes(productKey));
}
/**
 * Products whose deals are priced ONLY by their rule-based questionnaire, so the headless
 * (MCP / nightly document-estimation) pipeline must NOT run open-ended ad-hoc scope discovery on
 * them. Discovery is product-blind: on a Maxio deal it captured the client's Rillet GL work
 * (chart of accounts, trial balances, Rillet integration) as ad-hoc lines and re-priced the GL
 * sync the Maxio rules already price (+45 h, live local run, Oct 9). Other-product scope belongs
 * on that product's own deal (Harman, Oct 9: two deals). The interactive upload path already
 * skips discovery for these deals (rule-driven, not AI mode).
 *
 * Deliberately a product list, not an "is rule-driven" check: Rillet / NetSuite greenfield deals
 * on the headless path DO run discovery today and must keep doing so.
 */
export const HEADLESS_ADHOC_DISCOVERY_OFF_PRODUCT_KEYS = ['maxio:maxio'];
/** True when the headless pipeline must skip ad-hoc scope discovery for the DEAL's product. */
export function skipsHeadlessAdhocDiscovery(productKey) {
    return (!!productKey &&
        HEADLESS_ADHOC_DISCOVERY_OFF_PRODUCT_KEYS.includes(productKey));
}
//# sourceMappingURL=sow-products.js.map